import React from "react";
import { HighlightMatch } from "@sscs/ui";
import styles from "./serviceSummary.module.scss";
// TODO: consider having generic component for text with subtext
const ServiceSummary = ({ name, version, searchRegex, }) => {
    return (React.createElement("div", null,
        React.createElement(HighlightMatch, { value: name, regex: searchRegex !== null && searchRegex !== void 0 ? searchRegex : "" }),
        React.createElement("div", { className: styles.version }, version)));
};
export default ServiceSummary;
//# sourceMappingURL=ServiceSummary.js.map